import React, { FC, useState, useEffect, useRef, useCallback } from 'react';
import { Button } from '../ui/button'; // Adjust the import path as necessary
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../ui/card'; // Adjust the import path as necessary


interface ProdukterProps {
  onRequestDetails: (isOpen: boolean) => void; // passed from Carousel
}


const products = [
  {
    name: 'Nyslungad rå skogshonung',
    description: 'Fyllig och rund smak, där bina framförallt samlat nektar från ljung, hallon, blåbär och lingon men även närliggande ängsblommor.',
    price: '130 kr, 500g',
    image: '/pictures/honeypictures/produkter/farskhonung3burkar.webp',
  },
  {
    name: 'Fryst rå skogshonung',
    description: 'Fryst rå skogshonung med samma fylliga och runda smak som vår nyslungade. Fryses in direkt efter slungning för att bevara alla naturliga egenskaper.',
    price: 'Kommer snart',
  },

];

const Produkter: FC<ProdukterProps> = ({ onRequestDetails }) => {

  const modalRef = useRef<HTMLDivElement>(null); // Reference to the modal

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageClick = (image: string) => {
    setSelectedImage(image); // Set the selected image to show in the modal
    onRequestDetails(true); // Notify Carousel that the modal is open

  };

  const closeModal = useCallback(() => {
    setSelectedImage(null); // Close the modal
    onRequestDetails(false); // Notify Carousel that the modal is closed

  }, [onRequestDetails]);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        closeModal(); // Call closeModal if click is outside the modal
      }
    };

    if (selectedImage) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedImage, closeModal]);

  // Handle backdrop click to close modal
  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(event.target as Node)
    ) {
      closeModal();
    }
  };

  return (
    <div>
    <div className="text-center mb-8">
        <div className="max-w-2xl mx-auto">
          <h2 className="slide-item-title title" style={{paddingTop: 6}}>Våra produkter</h2>
            <p className="text-lg text-green-dark/80">
            Vår honung skördas varsamt för att bevara alla naturliga egenskaper och den underbara smaken.
            </p>
        </div>
    </div>
      <div className="flex flex-wrap justify-center gap-6 max-w-6xl mx-auto px-2">
        {products.map((product, index) => (
          <Card key={index} className="bg-custom-lightbrown border border-green-light/20 hover:shadow-md transition-shadow max-w-xs w-full mx-auto">
            <CardHeader>
              <CardTitle className="text-green-dark">{product.name}</CardTitle>
              <CardDescription>{product.description}</CardDescription>
            </CardHeader>
            <CardContent>

            <div className="aspect-[4/3] w-full rounded-lg overflow-hidden mb-4 shadow-md"
            onClick={() => product.image && handleImageClick(product.image)} // Handle image click
            >
            {product.image ? (
                <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover"
                />
            ) : (
                <span className="text-green-dark/50 flex items-center justify-center h-full">
                Produktbild
                </span>
            )}
            </div>


            </CardContent>
            <CardFooter className="flex justify-between items-center">
              <span className="font-bold text-green-dark">{product.price}</span>
              <Button 
                className="bg-honey hover:bg-honey-dark text-white border-none"
              >
                Köp nu
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          onClick={handleBackdropClick}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
          <div
            ref={modalRef}
            className="bg-white p-6 rounded-lg max-w-md w-full relative shadow-lg border border-gray-200"
          >
            <button
              className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-green-medium text-honey hover:bg-green-dark hover:green-medium transition-all duration-200 shadow-md text-sm"
              onClick={closeModal}
            >
              ✕
            </button>
            <div className="flex justify-center items-center">
              <img
                src={selectedImage}
                alt="Selected Product"
                className="w-full h-auto rounded-lg max-h-[80vh] object-contain"
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Produkter;